module.exports = __webpack_public_path__ + "static/media/accountant-online.10f94a6d.png";